import { DEFAULT_TIMEZONEID } from '../../api/constants';
import type { OrganizationConfigs, SupportedLanguages } from '../../models/OrganizationConfigs';
import type { OneStoreType } from '../store';

export const getEnv = (state: OneStoreType) => state.env;
export const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONEID;
export const getOrganizationConfigs = (state: OneStoreType): OrganizationConfigs => state.env.organizationConfigs;
export const getCurrentLanguage = (state: OneStoreType) => state.env.currentLanguage;
export const getAuthenticators = (state: OneStoreType) => state.env.organizationConfigs?.authenticatorsConfig;
export const getSupportedLanguages = (state: OneStoreType): SupportedLanguages[] =>
  state.env.organizationConfigs?.supportedLanguages;
